import { useQuery } from '@tanstack/react-query';

import { webFormsApi } from '../axios';
import { DocumentValidationResponse } from '../types';

export function useFormAnswerInfoQuery(formAnswerId: string, token?: string) {
  return useQuery({
    queryKey: ['formAnswerInfo', formAnswerId],
    queryFn: () => webFormsApi.getFormAnswerWithTaskData(formAnswerId, token),
    enabled: !!formAnswerId,
  });
}

export function useFormAnswerAnswersListQuery(formAnswerId: string, token?: string) {
  return useQuery({
    queryKey: ['formAnswerAnswersList', formAnswerId],
    queryFn: () =>
      token
        ? webFormsApi.getPublicFormAnswer(formAnswerId, token)
        : webFormsApi.getFormAnswer(formAnswerId),
    enabled: !!formAnswerId,
  });
}

export function useDocumentValidationQuery(md5Name: string | undefined) {
  return useQuery<DocumentValidationResponse>({
    queryKey: ['documentValidation', md5Name],
    queryFn: () => webFormsApi.getDocumentValidation(md5Name ?? ''),
    enabled: !!md5Name,
  });
}
